<div [ngClass]="overlay() ? 'fullscreen-container' : ''">
    @if (showThumbnail()) {
    <div id="thumbnailImageContainer"
        [ngClass]="fullscreen() ? 'fullscreen-image' : ''">
        @if (thumbnailUrl()) {
        <img [src]="thumbnailUrl()"
            alt="placeholder" />
        }
        @if (showSpinner()) {
        <div class="video-loading-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        }
    </div>
    }
    @if (unplayable()) {
    <ds-video-error animate.enter="ds-fade-enter" animate.leave="ds-fade-leave" />
    }
    <youtube-player
        [ngStyle]="{ 'display': showThumbnail() ? 'none' : 'block', 'position': overlay() ? 'unset' : 'relative' }"
        #player
        id="ytPlayer"
        [videoId]="videoId()"
        [playerVars]="playerVars()"
        animate.enter="ds-fade-enter" animate.leave="ds-fade-leave" />
</div>
